require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/modules/es6.array.species.js
// module id = 479
// module chunks = 0